module.exports = __webpack_public_path__ + "static/media/fertility-outreach-logo.7f00fd42.svg";